import Layout from "components/Layout";
import React  from "react";
import UserAddForm from "./components/UserAddForm";

function AdminUserAddPage() {
  return (
    <Layout title="사용자 등록">
      <UserAddForm />
    </Layout>
  );
}

export default AdminUserAddPage;
